import React from 'react';
import { FileDown, Printer, QrCode } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { PageHeader } from '../../components/admin/PageHeader';
import { A4Frame } from '../../components/notice/A4Frame';
import { SecureNotice } from '../../components/notice/SecureNotice';
export function SampleNotice() {
  const navigate = useNavigate();
  return <div data-id="element-1606" data-mp="2xlt2gwho7sr9">
      <PageHeader screen="WEB SCREEN 10" title="নমুনা নিরাপদ ডিএমপি প্রসিকিউশন নোটিশ" subtitle="প্রিন্টযোগ্য A4 • সরকারি লেটারহেড • QR যাচাই ব্লক • ডিজিটাল স্বাক্ষর" actions={<>
            <Button variant="outline" onClick={() => navigate('/admin/qr-data')} data-id="element-1608" data-mp="2jtd6ugr3mx0d"><QrCode className="h-4 w-4" data-id="element-1609" data-mp="3h7z48le5g3li" /> QR তথ্যসেট</Button>
            <Button variant="outline" onClick={() => {
        toast.success('PDF ডাউনলোড শুরু হয়েছে', {
          description: 'DMP-DOC-2025-0748-V1.pdf'
        });
        window.print();
      }} data-id="element-1610" data-mp="3h9ik4avw8cmr"><FileDown className="h-4 w-4" data-id="element-1611" data-mp="4qpvmblt136m" /> PDF</Button>
            <Button onClick={() => window.print()} data-id="element-1612" data-mp="4r801vimenpm"><Printer className="h-4 w-4" data-id="element-1613" data-mp="9p9iqfc4wl0k" /> প্রিন্ট করুন</Button>
          </>} data-id="element-1607" data-mp="2tid5fz1ovqe1" />
      <div className="rounded-lg bg-slate-200/70 p-4 md:p-8" data-id="element-1614" data-mp="3s3igm5foxrdx">
        <div className="mx-auto max-w-[794px] shadow-xl" data-id="element-1615" data-mp="3s30kr9wxxf6j">
          <A4Frame data-id="element-1616" data-mp="3w4ls6fqph19c"><SecureNotice data-id="element-1617" data-mp="3w4c2kt9kow46" /></A4Frame>
        </div>
      </div>
    </div>;
}